import { Routes, Route } from "react-router";

import { Home } from './pages/home'
import { Article1 } from "./pages/home/components/Article1";
import { Article2 } from "./pages/home/components/Article2";
import { Article3 } from "./pages/home/components/Article3";
import { Article4 } from "./pages/home/components/Article4";
import { Article5 } from "./pages/home/components/Article5";
import { Article6 } from "./pages/home/components/Article6";
import { Article7 } from "./pages/home/components/Article7";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/about-day-care" element={<Article1/>} />
      <Route path="/world-of-dogs" element={<Article2/>} />
      <Route path="/dog-breed-guide" element={<Article3/>}/>
      <Route path="/traveling-with-dog" element={<Article4/>} />
      <Route path="/dog-training" element={<Article5/>}/>
      <Route path="/dog-behaviour" element={<Article6/>}/>
      <Route path="/adopting-dog" element={<Article7/>}/>
     
   </Routes>
  );
}
export default App;